import { useState, useEffect } from "react";
import { AlertTriangle, DollarSign, Clock, Users, Info, ChevronRight, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

var ALERT_ICONS = {
  commission_blocked: DollarSign,
  payment_overdue: AlertTriangle,
  payment_upcoming: Clock,
  lead_stale: Users,
  commission_pending_old: Info,
  policy_expiring: Shield,
};
var SEVERITY_CLS = {
  high: "border-red-200 bg-red-50",
  medium: "border-amber-200 bg-amber-50",
  low: "border-blue-200 bg-blue-50",
};
var SEVERITY_ICON_CLS = {
  high: "text-red-500 bg-red-100",
  medium: "text-amber-500 bg-amber-100",
  low: "text-blue-500 bg-blue-100",
};

export default function AlertsWidget() {
  var alertsState = useState([]);
  var alerts = alertsState[0];
  var setAlerts = alertsState[1];
  var navigate = useNavigate();

  useEffect(function() {
    api.get("/reports/alerts").then(function(res) {
      setAlerts(res.data.alerts || []);
    }).catch(function() {});
  }, []);

  if (alerts.length === 0) return null;

  var highAlerts = alerts.filter(function(a) { return a.severity === "high"; });
  var displayAlerts = highAlerts.length > 0 ? highAlerts : alerts.slice(0, 3);

  return (
    <div className="bg-white rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-sm mb-6 lg:mb-8" data-testid="dashboard-alerts-widget">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-amber-500" />
          <h3 className="text-base lg:text-lg font-bold text-[#0A2F3D]">Alertas</h3>
          <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-600">{alerts.length}</span>
        </div>
        <button onClick={function() { navigate("/relatorios"); }} className="flex items-center gap-1 text-xs text-[#3B82F6] font-medium hover:underline" data-testid="alerts-see-all">
          Ver todos<ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="space-y-2">
        {displayAlerts.map(function(alert, idx) {
          var Icon = ALERT_ICONS[alert.type] || Info;
          var cls = SEVERITY_CLS[alert.severity] || SEVERITY_CLS.low;
          var iconCls = SEVERITY_ICON_CLS[alert.severity] || SEVERITY_ICON_CLS.low;
          return (
            <div key={idx} className={"flex items-start gap-3 p-3 rounded-xl border " + cls} data-testid={"dashboard-alert-" + idx}>
              <div className={"p-1.5 rounded-lg flex-shrink-0 " + iconCls}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-semibold text-gray-800">{alert.title}</p>
                <p className="text-xs text-gray-600">{alert.message}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
